/* rb-m-cart.js -- the cart drawer. Phone only, needs window.RBM. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* ---- the total lives in the button ----------------------------------------
     "Check out - $180.00" replaces a 48px Subtotal row above the button: the
     number a buyer wants at the moment of deciding is on the control that
     acts on it, and the footer gets 48px back for content. The value is read
     from the theme's own subtotal (.ajaxcart__footer-total .money), never
     computed here, so discounts and currency come through as the theme
     renders them. The drawer re-renders its whole HTML on every cart change,
     so this runs again whenever a footer appears. */
  RBM.onMobile('cart-total-btn', function () {
    function apply() {
      var foot = document.querySelector('.mfp-content .ajaxcart__footer') || document.querySelector('.ajaxcart__footer');
      if (!foot) return;
      var money = foot.querySelector('.ajaxcart__footer-total .money');
      var btn = foot.querySelector('.ajaxcart__checkout');
      if (!money || !btn) return;
      var total = (money.textContent || '').replace(/\s+/g, ' ').trim();
      if (!total) return;
      var span = btn.querySelector('.rbm-btn-total');
      if (!span) {
        span = document.createElement('span');
        span.className = 'rbm-btn-total';
        btn.appendChild(span);
      }
      if (span.textContent !== total) span.textContent = total;
      foot.classList.add('rbm-total-in-btn');
    }
    apply();
    if (window.MutationObserver) {
      new MutationObserver(RBM.debounce(apply, 80)).observe(document.body, { childList: true, subtree: true });
    }
  });
})();
